<template lang="pug">
  d-input-base(
    component="ev-tiptap-editor"
    v-bind="extendAttrs"
    v-on="$listeners"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
import DInputBase from './DInputBase.vue';
import { VTextField } from 'vuetify/lib';

export default {
  components:  {
    DInputBase,
    VTextField,
  },
  computed: {
    extendAttrs() {
      return {
        placeholder: 'Начните вводить...',
        height: 48,
        ...this.$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-tiptap-editor .v-toolbar__content > .d-flex {
  overflow: auto;
  & button {
    padding: 0 8px !important;
    height: 36px !important;
    min-width: 36px !important;
    align-self: center;
  }
}
</style>
